import { render, staticRenderFns } from "./candidate-name.vue?vue&type=template&id=226f784e&"
import script from "./candidate-name.vue?vue&type=script&lang=ts&"
export * from "./candidate-name.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports